// extracted by mini-css-extract-plugin
export var header = "_f4-0";